import React from 'react';
import { Helmet } from 'react-helmet-async';

import S from './PageMain.module.css';

import { Work } from './Work';
import { A } from '../../components/Content/A';

const Atlassian = () => <A href="https://atlassian.com/">Atlassian</A>;

const techIcons = {
  puppeteer: 'puppeteer.png',
  sinon: 'sinon.png',
  webdriverio: 'webdriverio.png',
  html: 'html5.svg',
  css: 'css3.svg'
};

const techLegacy = [
  'Flow',
  'Redux',
  'WebdriverIO',
  'Grunt',
  'Gulp',
  'Mocha',
  'Sinon',
  'Chai',
  'jQuery',
  'Backbone'
];

const TechStack = ({
  items: originalItems,
  sort: isSortingEnabled = false
}: {
  items: string[];
  sort?: boolean;
}) => {
  const items = isSortingEnabled
    ? originalItems.sort((a, b) => (a.toLowerCase() > b.toLowerCase() ? 1 : -1))
    : originalItems;

  return (
    <div className={S.techStack}>
      {items.map((item, idx) => {
        const name = item.toLowerCase();
        return (
          <div
            className={S.techItem}
            key={idx}
            data-legacy={techLegacy.includes(item) ? true : undefined}
          >
            <picture>
              <img
                src={`/img/icons/tech/${techIcons[name] || `${name}.svg`}`}
                alt={item}
              />
            </picture>
            {item}
          </div>
        );
      })}
    </div>
  );
};

const PageMain = () => {
  return (
    <>
      <Helmet>
        <title>Vasyl Zubach - Software Engineer</title>
      </Helmet>
      <section className="w-900">
        <picture className={S.avatar}>
          <img
            src="/img/ava.jpg"
            srcSet="/img/ava@2x.jpg 2x, /img/ava@3x.jpg 3x"
            width="400"
            alt="Vasyl Zubach"
          />
        </picture>

        {/* <p className={S.center}>
        <A href={'/notes/8/stand-with-ukraine'} className={S.status}>
          <img src="/img/ukraine-flag.svg" width={30} />
          <span>#StandWithUkraine</span>
        </A>
      </p> */}

        <br />

        <h1>About me</h1>
        <p>
          Hi there 👋
          <br />
          My name is <strong>Vasyl Zubach</strong>. I&apos;m a{' '}
          <strong>Software Engineer</strong> passioned about interfaces, user
          experience, and dev experience. Improve every aspect of those through
          developing frontend components, plugins, improving performance and
          accessibility, exploring and developing tools to optimise devloop.
        </p>
        <p>
          I currently live in Sydney, Australia and work at {<Atlassian />}{' '}
          (since November 2015).
        </p>
        <br />
        <br />
        <h2>Tech Stack:</h2>
        <p>Technologies I use for my day-to-day work and ideas:</p>
        <TechStack
          items={['HTML', 'CSS', 'JavaScript', 'TypeScript', 'NodeJS']}
        />
        <br />
        <details>
          <summary>More stuff I use/used:</summary>
          <p>
            Here technologies will be listed alongside libraries, frameworks and
            tools.
          </p>
          <h3>Frontend:</h3>
          <TechStack
            items={[
              'HTML',
              'CSS',
              'JavaScript',
              'TypeScript',
              'React',
              'Bootstrap',
              'ApolloClient',
              'SASS',
              'Highcharts',
              'Backbone',
              'jQuery',
              'Flow',
              'Redux'
            ]}
          />
          <h3>Backend:</h3>
          <TechStack
            items={['NodeJS', 'NextJS', 'GraphQL', 'Express', 'Koa']}
          />
          <TechStack items={['PHP', 'Codeigniter', 'Laravel', 'MySQL']} />
          <TechStack items={['MySQL']} />
          <h3>App development:</h3>
          <TechStack items={['Electron']} />
          <h3>Unit testing:</h3>
          <TechStack items={['Jest', 'Mocha', 'Sinon', 'Chai']} />
          <h3>Autommation (including QA Autommation)</h3>
          <TechStack
            items={['Puppeteer', 'Playwright', 'Cypress', 'WebdriverIO']}
          />
          <h3>Code quality tools:</h3>
          <TechStack items={['Prettier', 'ESLint']} />
          <h3>Build Tools:</h3>
          <TechStack items={['Webpack', 'Babel', 'PostCSS', 'Grunt', 'Gulp']} />
        </details>
        <br />
        <br />
        <h2>Work experience:</h2>
        <Work />
      </section>
    </>
  );
};

export default PageMain;
